import React from "react";
import { connect } from "react-redux";

import { getPaymentByID } from "state/school_money/selectors";

import Currency from "components/Currency";
import PaymentInstallment from "components/school_money/basket/items/payment/PaymentInstallment";

import "./Payment.css";

class Payment extends React.Component {
  
  render() {
    
    const { payment, installments, totalPrice } = this.props;
    const { description } = payment.toObject();
    
    return (
      <div className="payment-basket-item">
        <div className="payment-basket-item__header">
          <div className="payment-basket-item__description">{description}</div>
          <div className="payment-basket-item__price">
            <div className="payment-basket-item__price-amount">
              <Currency amount={totalPrice} />
            </div>
            <div className="payment-basket-item__button-placeholder"></div>
          </div>
        </div>
        <table className="payment-basket-item__installments">
          <tbody>
            {
              installments.map(payload => (
                <PaymentInstallment
                  key={payload.get("installmentNumber")}
                  paymentID={payload.get("paymentID")}
                  installmentNumber={payload.get("installmentNumber")}
                />
              ))
            }
          </tbody>
        </table>
      </div>
    )
    
  }
  
}

export default connect(
  (state, { paymentID }) => ({
    payment: getPaymentByID(state, paymentID)
  })
)(Payment);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/items/payment/Payment.js